module.exports = __webpack_public_path__ + "img/caret-up.41c1511d.png";